<template>
  <v-data-table
    :headers="headers"
    :items="content"
    hide-actions
    :custom-sort="customSort"
    :pagination.sync="pagination"
  >
    <template slot="items" slot-scope="props">
      <td class="text-xs-right">{{ props.item.doc_id }}</td>
      <td>
        <div v-if="props.item.name === 'rashodnayanakladnaya'" class="rashodnayanakladnaya-title">
          <v-tooltip right>
            <div slot="activator">
              {{ props.item.doc_title }}
              <v-progress-linear
                color="accent"
                class="rashodnayanakladnaya-status"

                height="5"
                :value="statuses[props.item.cond].value"
              />
            </div>
            <span>{{statuses[props.item.cond].tooltip}}</span>
          </v-tooltip>
        </div>
        <template v-else>
          {{ props.item.doc_title }}
        </template>
      </td>
      <td>{{ props.item.created_on }}</td>
      <td class="text-xs-right">
        {{ props.item.summa }}
        <span class="grey--text currency">{{currencies[props.item.valuti_id]}}</span>
      </td>
      <td>{{ props.item.comment }}</td>
      <td class="text-xs-left">
        <v-tooltip bottom>
          <v-icon
            class="mr-2"
            slot="activator"
            @click="openDocument(props.item)"
          >
            mdi-pencil
          </v-icon>
          <span>Открыть</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-icon
            v-if="allowEditList.indexOf(props.item.name) > - 1"
            class="mr-2"
            slot="activator"
            @click="openCatalog(props.item)"
          >
            mdi-plus
          </v-icon>
          <span>Добавить товар</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-icon
            v-if="allowEditList.indexOf(props.item.name) > - 1"
            slot="activator"
            color="red"
            @click="openDeleteConfirmationModal(props.item)"
          >
            mdi-delete
          </v-icon>
          <span>Удалить</span>
        </v-tooltip>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import documentsDisplay from '../mixins/documentsDisplay'

export default {
  name: 'DocumentsTable',
  mixins: [
    documentsDisplay
  ],
  data () {
    return {
      pagination: {
        sortBy: 'created_on',
        descending: true,
        rowsPerPage: -1
      },
      headers: [
        {
          text: '№',
          align: 'right',
          width: '100px',
          value: 'doc_id'
        },
        {
          text: 'Документ',
          width: '190px',
          value: 'doc_title'
        },
        {
          text: 'Дата',
          width: '200px',
          value: 'created_on'
        },
        {
          text: 'Сумма',
          width: '150px',
          align: 'right',
          value: 'summa'
        },
        {
          text: 'Комментарий',
          value: 'comment'
        },
        {
          text: '',
          align: 'center',
          width: '145px',
          value: 'actions',
          sortable: false
        }
      ]
    }
  },
  watch: {
    pagination: {
      handler (val) {
        localStorage.setItem('documents_table_sort', JSON.stringify({
          sortBy: val.sortBy,
          descending: val.descending
        }))
      },
      deep: true
    }
  },

  created () {
    const savedSort = localStorage.getItem('documents_table_sort')
    if (savedSort) {
      try {
        const parsed = JSON.parse(savedSort)
        // Применяем только сохраненную сортировку к текущему объекту pagination
        // rowsPerPage останется равным -1 (как задано в data)
        if (parsed.sortBy) this.pagination.sortBy = parsed.sortBy
        if (parsed.descending !== undefined) this.pagination.descending = parsed.descending
      } catch (e) {
        console.error('Error parsing saved sort', e)
      }
    }
  },
  methods: {
    customSort (items, index, isDescending) {
      items.sort((a, b) => {
        if (index === 'created_on') {
          if (isDescending) {
            return 1
          } else {
            return -1
          }
        } else if (index === 'summa' || index === 'doc_id') {
          if (!isDescending) {
            return parseFloat(a[index]) < parseFloat(b[index]) ? -1 : 1
          } else {
            return parseFloat(b[index]) < parseFloat(a[index]) ? -1 : 1
          }
        } else {
          if (!isDescending) {
            return a[index] < b[index] ? -1 : 1
          } else {
            return b[index] < a[index] ? -1 : 1
          }
        }
      })

      return items
    }
  }
}
</script>

<style scoped>

</style>
